import { render, staticRenderFns } from "./ClearCompetencyGridsPage.vue?vue&type=template&id=f97aa1e2"
import script from "./ClearCompetencyGridsPage.vue?vue&type=script&lang=js"
export * from "./ClearCompetencyGridsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports